/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';

import ShareCardBottomBar from '../components/ShareCardBottomBar';
import { ShareCardHeaderNoTitle } from '../components/ShareCardHeaderTitle';
import TextArea from '../../../components/TextArea';
import { ShareCard } from '../../../../models/ShareCardModel.js';

interface Props {
  shareCardColorModel: any;
  shareCard: ShareCard;
  updateComment(d): void;
  closeComment(): void;
}
const ShareCardEditComment: React.FC<Props> = (props) => {
  const { shareCardColorModel, shareCard, closeComment, updateComment } = props;
  const backgroundColor = shareCardColorModel.cssColor(0.05);
  const shareCardId = shareCard.id;

  const [state, setState] = React.useState({
    showComment: false,
    commentText: shareCard.comment || '',
    isEditing: !shareCard.comment,
  });

  return (
    <div className="cmp-sharecardtemplate" id={shareCardId.toString()}>
      <ShareCardHeaderNoTitle
        cssColor={backgroundColor}
        isEditingTitle={state.isEditing}
        cancelChange={() => {
          setState({
            ...state,
            commentText: props.shareCard.comment || '',
            isEditing: false,
          });
          closeComment();
        }}
        onDone={() => {
          updateComment(state.commentText);
        }}
        onSubmit={() => { setState({ ...state, isEditing: false }); }}
      />

      <div style={{ height: '100%', width: '100%', display: 'flex' }}>
        <TextArea
          className="cmp-paddedcontent util-application-frame-forcards-padding"
          height="100%"
          value={state.commentText}
          onChange={(event) => { setState({ ...state, commentText: event.target.value }); }}
          defaultFocus={!state.commentText}
          onFocus={() => {
            setState({
              ...state,
              isEditing: true,
            });
          }}
          fontColor="font-color-textarea-dark"
        />
      </div>

      <ShareCardBottomBar cssColor={backgroundColor} />
    </div>
  );
};

export default ShareCardEditComment;
